import type { AllRouteEndpoints } from "../routeTypes";
export const engagementEmailTemplatesUpdateTagsCacheKeys: AllRouteEndpoints[] = [
  "/engagement/email_templates/tags",
  "/engagement/email_templates",
  "/engagement/email_draganddrop_templates",
  "/engagement/email_draganddrop_templates/tags",
];
